import React from 'react';
import './App.css';
import GithubAPI from './components/GithubApi';

function App() {
  return (
    <div className="App">
      <nav className='navbar navbar-dark bg-dark'>
         <a href='/' className='navbar-brand mx-4'>Github User Search</a>
      </nav>
      <GithubAPI/>
    </div>
  );
}

export default App;
